import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  divider: {
    marginLeft: 10,
    marginRight: 10,
  },
  tabsRoot: {
    display: 'flex',
  },
  tabRoot: {
    flex: 1,
  },
  tab: {
    padding: 10,
  },
  datePickerWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20,
  },
  datePicker: {
    borderBottom: `1px solid ${theme.custom.darkBlue}`,
  },
  mt20: {
    marginTop: 20,
  },
  title: {
    margin: 0,
    padding: 0,
    marginBottom: 20,
    fontSize: 16,
    color: theme.custom.darkBlue,
    textAlign: 'center',
  },
}));
